import {
  RetrieveGlobalTournamentDetails,
  RetrieveGlobalTournamentDetailsFailure,
  RetrieveGlobalTournamentDetailsPayload,
  RetrieveGlobalTournamentDetailsSuccess,
  RetrieveGlobalTournamentDetailsSuccessPayload,
  RetrieveTournamentDetails,
  RetrieveTournamentDetailsFailure,
  RetrieveTournamentDetailsPayload,
  RetrieveTournamentDetailsSuccess,
  RetrieveTournamentDetailsSuccessPayload,
  RetrieveTournaments,
  RetrieveTournamentsByUser,
  RetrieveTournamentsByUserFailure,
  RetrieveTournamentsByUserPayload,
  RetrieveTournamentsByUserSuccess,
  RetrieveTournamentsByUserSuccessPayload,
  RetrieveTournamentsCreatedByUser,
  RetrieveTournamentsCreatedByUserFailure,
  RetrieveTournamentsCreatedByUserPayload,
  RetrieveTournamentsCreatedByUserSuccess,
  RetrieveTournamentsCreatedByUserSuccessPayload,
  RetrieveTournamentsFailure,
  RetrieveTournamentsPayload,
  RetrieveTournamentsSuccess,
  RetrieveTournamentsSuccessPayload,
  RETRIEVE_GLOBAL_TOURNAMENT_DETAILS,
  RETRIEVE_GLOBAL_TOURNAMENT_DETAILS_FAILURE,
  RETRIEVE_GLOBAL_TOURNAMENT_DETAILS_SUCCESS,
  RETRIEVE_TOURNAMENTS_BY_USER,
  RETRIEVE_TOURNAMENTS_BY_USER_FAILURE,
  RETRIEVE_TOURNAMENTS_BY_USER_SUCCESS,
  RETRIEVE_TOURNAMENTS_CREATED_BY_USER,
  RETRIEVE_TOURNAMENTS_CREATED_BY_USER_FAILURE,
  RETRIEVE_TOURNAMENTS_CREATED_BY_USER_SUCCESS,
  RETRIEVE_TOURNAMENTS_FAILURE,
  RETRIEVE_TOURNAMENTS_SUCCESS,
  RETRIEVE_TOURNAMENT_DETAILS,
  RETRIEVE_TOURNAMENT_DETAILS_FAILURE,
  RETRIEVE_TOURNAMENT_DETAILS_SUCCESS,
} from './tournament.action.type';

export const RETRIEVE_TOURNAMENTS = 'RETRIEVE_TOURNAMENTS';

export const retrieveTournaments = (
  payload: RetrieveTournamentsPayload,
): RetrieveTournaments => ({
  type: RETRIEVE_TOURNAMENTS,
  payload,
});

export const retrieveTournamentsSuccess = (
  payload: RetrieveTournamentsSuccessPayload,
): RetrieveTournamentsSuccess => ({
  type: RETRIEVE_TOURNAMENTS_SUCCESS,
  payload,
});

export const retrieveTournamentsFailure = (
  error: string,
): RetrieveTournamentsFailure => ({
  type: RETRIEVE_TOURNAMENTS_FAILURE,
  payload: error,
});

export const retrieveTournamentsByUser = (
  payload: RetrieveTournamentsByUserPayload,
): RetrieveTournamentsByUser => ({
  type: RETRIEVE_TOURNAMENTS_BY_USER,
  payload,
});

export const retrieveTournamentsByUserSuccess = (
  payload: RetrieveTournamentsByUserSuccessPayload,
): RetrieveTournamentsByUserSuccess => ({
  type: RETRIEVE_TOURNAMENTS_BY_USER_SUCCESS,
  payload,
});

export const retrieveTournamentsByUserFailure = (
  error: string,
): RetrieveTournamentsByUserFailure => ({
  type: RETRIEVE_TOURNAMENTS_BY_USER_FAILURE,
  payload: error,
});

export const retrieveTournamentsCreatedByUser = (
  payload: RetrieveTournamentsCreatedByUserPayload,
): RetrieveTournamentsCreatedByUser => ({
  type: RETRIEVE_TOURNAMENTS_CREATED_BY_USER,
  payload,
});

export const retrieveTournamentsCreatedByUserSuccess = (
  payload: RetrieveTournamentsCreatedByUserSuccessPayload,
): RetrieveTournamentsCreatedByUserSuccess => ({
  type: RETRIEVE_TOURNAMENTS_CREATED_BY_USER_SUCCESS,
  payload,
});

export const retrieveTournamentsCreatedByUserFailure = (
  error: string,
): RetrieveTournamentsCreatedByUserFailure => ({
  type: RETRIEVE_TOURNAMENTS_CREATED_BY_USER_FAILURE,
  payload: error,
});

export const retrieveTournamentDetails = (
  payload: RetrieveTournamentDetailsPayload,
): RetrieveTournamentDetails => ({
  type: RETRIEVE_TOURNAMENT_DETAILS,
  payload,
});

export const retrieveTournamentDetailsSuccess = (
  payload: RetrieveTournamentDetailsSuccessPayload,
): RetrieveTournamentDetailsSuccess => ({
  type: RETRIEVE_TOURNAMENT_DETAILS_SUCCESS,
  payload,
});

export const retrieveTournamentDetailsFailure = (
  error: string,
): RetrieveTournamentDetailsFailure => ({
  type: RETRIEVE_TOURNAMENT_DETAILS_FAILURE,
  payload: error,
});

export const retrieveGlobalTournamentDetails = (
  payload: RetrieveGlobalTournamentDetailsPayload,
): RetrieveGlobalTournamentDetails => ({
  type: RETRIEVE_GLOBAL_TOURNAMENT_DETAILS,
  payload,
});

export const retrieveGlobalTournamentDetailsSuccess = (
  payload: RetrieveGlobalTournamentDetailsSuccessPayload,
): RetrieveGlobalTournamentDetailsSuccess => ({
  type: RETRIEVE_GLOBAL_TOURNAMENT_DETAILS_SUCCESS,
  payload,
});

export const retrieveGlobalTournamentDetailsFailure = (
  error: string,
): RetrieveGlobalTournamentDetailsFailure => ({
  type: RETRIEVE_GLOBAL_TOURNAMENT_DETAILS_FAILURE,
  payload: error,
});
